/** Official PocketBillingAI v1.9.8 install links (Google Drive + Play Store). */
export const GOOGLE_PLAY_APP_URL =
  'https://play.google.com/store/apps/details?id=in.restroai.lite';

export const DOWNLOAD_LINKS = {
  macIntel: {
    id: 'mac-intel',
    label: 'Mac — Intel chip',
    shortLabel: 'Mac Intel',
    icon: '🍎',
    href: 'https://drive.google.com/file/d/1a4Kx92x1duKXMhZ6XucjIxyOKPWVBec0/view?usp=sharing',
    fileName: 'PocketBillingAI-1.9.8.dmg',
    description:
      'For MacBook / iMac with Intel processor. Download the DMG, open it, and drag PocketBillingAI to Applications.',
    requirements: 'macOS 10.12 or later · Intel Mac',
    cta: 'Download for Mac (Intel)',
  },
  macSilicon: {
    id: 'mac-silicon',
    label: 'Mac — Apple Silicon (M1/M2/M3)',
    shortLabel: 'Mac Apple Silicon',
    icon: '💻',
    href: 'https://drive.google.com/file/d/1Cgpwg8Mx_z3ufPxFqPiR5iBIJRoA8PiD/view?usp=sharing',
    fileName: 'PocketBillingAI-1.9.8-SiliconM1Chip.dmg',
    description:
      'For MacBook Air/Pro and Mac mini with M1, M2, M3, or M4 chip. Best performance on Apple Silicon.',
    requirements: 'macOS 11 or later · Apple Silicon',
    cta: 'Download for Mac (Apple Silicon)',
  },
  windows: {
    id: 'windows',
    label: 'Windows PC',
    shortLabel: 'Windows',
    icon: '🪟',
    href: 'https://drive.google.com/file/d/107NDqgEYA7mIX4yJXY892a5OJDNCxfli/view?usp=sharing',
    fileName: 'PocketBillingAI-1.9.8-x64.exe',
    description:
      'Installer for shop counter PCs and laptops. Run the setup wizard and sign in with your registered mobile number.',
    requirements: 'Windows 10 or 11 · 64-bit',
    cta: 'Download for Windows',
  },
  googlePlay: {
    id: 'android',
    label: 'Android — Google Play',
    shortLabel: 'Google Play',
    icon: '▶',
    href: GOOGLE_PLAY_APP_URL,
    fileName: 'PocketBillingAI on Play Store',
    description:
      'Install on your phone or tablet from Google Play. Works fully offline on device; optional Google Drive sync with desktop.',
    requirements: 'Android 8+ · Package in.restroai.lite',
    cta: 'Get it on Google Play',
  },
};

export const DOWNLOAD_LINK_LIST = [
  DOWNLOAD_LINKS.macSilicon,
  DOWNLOAD_LINKS.macIntel,
  DOWNLOAD_LINKS.windows,
  DOWNLOAD_LINKS.googlePlay,
];
